export const CATEGORIE = [
  { value: "pubblica_amministrazione", label: "Pubblica Amministrazione" },
  { value: "azienda_edile", label: "Azienda Edile" },
  { value: "rivenditore", label: "Rivenditore" },
  { value: "privato", label: "Privato" },
  { value: "conto_terzi", label: "Conto Terzi" },
  { value: "carpenteria", label: "Carpenteria" },
  { value: "altro", label: "Da Categorizzare" },
];

export const STATI = [
  { value: "potenziale", label: "Potenziale" },
  { value: "attivo", label: "Attivo" },
  { value: "perso", label: "Perso" },
];

export const PRIORITA = [
  { value: "bassa", label: "Bassa" },
  { value: "media", label: "Media" },
  { value: "alta", label: "Alta" },
];

export const OPERATORI = [
  { value: "Commerciale 1", label: "Commerciale 1" },
  { value: "Commerciale 2", label: "Commerciale 2" },
  { value: "Commerciale 3", label: "Commerciale 3" },
  { value: "Commerciale 4", label: "Commerciale 4" },
  { value: "Commerciale 5", label: "Commerciale 5" },
  { value: "Commerciale 6", label: "Commerciale 6" },
  { value: "Commerciale 7", label: "Commerciale 7" },
  { value: "Commerciale 8", label: "Commerciale 8" },
  { value: "Commerciale 9", label: "Commerciale 9" },
  { value: "Commerciale 10", label: "Commerciale 10" },
];

export const categoriaLabel = (v) =>
  CATEGORIE.find((c) => c.value === v)?.label || "—";

export const statoLabel = (v) => STATI.find((c) => c.value === v)?.label || "—";

export const statoBadgeClass = (v) => {
  switch (v) {
    case "attivo":
      return "bg-emerald-50 text-emerald-700 border-emerald-200";
    case "potenziale":
      return "bg-amber-50 text-amber-800 border-amber-200";
    case "perso":
      return "bg-stone-100 text-stone-600 border-stone-200";
    default:
      return "bg-stone-100 text-stone-600 border-stone-200";
  }
};

export const categoriaBadgeClass = (v) => {
  switch (v) {
    case "pubblica_amministrazione":
      return "bg-blue-50 text-blue-700 border-blue-200";
    case "azienda_edile":
      return "bg-[#F56A1F]/10 text-[#F56A1F] border-[#F56A1F]/20";
    case "rivenditore":
      return "bg-emerald-50 text-emerald-700 border-emerald-200";
    case "privato":
      return "bg-indigo-50 text-indigo-700 border-indigo-200";
    case "conto_terzi":
      return "bg-purple-50 text-purple-700 border-purple-200";
    case "carpenteria":
      return "bg-amber-50 text-amber-800 border-amber-200";
    case "altro":
      return "bg-stone-100 text-stone-600 border-stone-200";
    default:
      return "bg-stone-100 text-stone-600 border-stone-200";
  }
};

const MESI = [
  "gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno",
  "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre",
];

export const formatDateIt = (isoDate) => {
  if (!isoDate) return "—";
  const d = new Date(isoDate);
  if (isNaN(d)) return isoDate;
  return `${d.getDate()} ${MESI[d.getMonth()]} ${d.getFullYear()}`;
};

export const formatDateShort = (isoDate) => {
  if (!isoDate) return "—";
  const d = new Date(isoDate);
  if (isNaN(d)) return isoDate;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
};

export const formatDateTimeIt = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()} · ${hh}:${mi}`;
};

export const isToday = (iso) => {
  if (!iso) return false;
  const d = new Date(iso);
  const n = new Date();
  return (
    d.getFullYear() === n.getFullYear() &&
    d.getMonth() === n.getMonth() &&
    d.getDate() === n.getDate()
  );
};

export const isOverdue = (iso) => {
  if (!iso) return false;
  const d = new Date(iso);
  const n = new Date();
  n.setHours(0, 0, 0, 0);
  return d < n;
};

export const initials = (name = "") => {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase())
    .join("");
};

export const todayISODate = () => {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
};

export const nowLocalDatetimeInput = () => {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}T${hh}:${mi}`;
};

export const localToIso = (localDatetime) => {
  if (!localDatetime) return null;
  return new Date(localDatetime).toISOString();
};

export const isoToLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const yy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${yy}-${mm}-${dd}T${hh}:${mi}`;
};
